import logo from "../../assets/imgs/easyfmm_logo.png";
import { useState } from "react";
import { Container, Navbar, Nav, NavDropdown, Button } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import "./navbar.css";
import GetQuote from "./GetQuote";
import ThankMsg from "./ThankMsg";

const NavBarComponent = () => {
  // const style = {
  //   textDecoration: "none",
  //   color: "#333",
  // }
  // const [show, setShow] = useState(false);
  const [fixed, setFixed] = useState(false);

  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      setFixed(true);
    } else {
      setFixed(false);
    }
  });

  const routes = [
    {
      name: "Home",
      link: "/",
    },
    {
      name: "Tracking",
      link: "/tracking",
    },
    {
      name: "Services",
      link: "/services",
    },
    {
      name: "About Us",
      link: "/about-us",
    },
    {
      name: "Contact Us",
      link: "/contact-us",
    },
    {
      name: "FAQ",
      link: "/FAQ",
    },
  ];
  const [isOpen, setIsOpen] = useState(false);
  const [isMsgOpen, setIsMsgOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);
  const msgToggle = () => {
    setIsMsgOpen(!isMsgOpen);
  };

  const location = useLocation();

  return (
    <>
      <Navbar
        bg="light"
        expand="lg"
        fixed={fixed ? "top" : ""}
        className="py-4"
      >
        <Container>
          <div>
            <Navbar.Brand>
              <NavLink to="/">
                <img src={logo} alt="logo" className="navbar-icon" />
              </NavLink>
            </Navbar.Brand>
          </div>
          <div>
            <div>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <div className="navbar-collapse">
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">
                    {routes.map((route, index) => (
                      <Nav.Link key={`nav-key-${index}`}>
                        <span
                          className={`link-style ${
                            route.link === location.pathname ? "active" : ""
                          }`}
                          onClick={() => (window.location = route.link)}
                        >
                          {route.name}
                        </span>
                      </Nav.Link>
                    ))}
                    <Nav.Link className="p-0 m-0 pb-3">
                      <Button
                        style={{ backgroundColor: "#1A2753" }}
                        className=" d-lg-block"
                        onClick={toggle}
                      >
                        Get a Quote
                      </Button>
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </div>
            </div>
          </div>
        </Container>
      </Navbar>

      <GetQuote isOpen={isOpen} toggle={toggle} msgToggle={msgToggle} />
      <ThankMsg msgToggle={msgToggle} isMsgOpen={isMsgOpen} />
    </>
  );
};

export default NavBarComponent;
